export default "__VITE_ASSET__DsqTa2Lg__"